export const normalizeReasoning = (input) => {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input
      .flatMap((item) => normalizeReasoning(item))
      .filter((item) => item && item.trim().length > 0);
  }

  if (typeof input === "string") {
    const trimmed = input.trim();
    if (!trimmed) {
      return [];
    }

    return trimmed
      .split(/\n+|(?<=[.!?])\s+(?=[A-Z0-9-])/g)
      .map((part) => part.trim())
      .filter(Boolean);
  }

  if (typeof input === "object") {
    if (typeof input.text === "string") {
      return normalizeReasoning(input.text);
    }
    if (typeof input.content === "string") {
      return normalizeReasoning(input.content);
    }
  }

  return [];
};
